import { createStaticReducer } from '../../utils/redux/createStaticReducer';

export const filtersUrlReducer = createStaticReducer<string | null>(null);
